export interface DisplaySettings {
  cardTitleFontSize: number;
  cardPositionFontSize: number;
  /**
   * @deprecated The dashboard no longer renders a per-card memo line, so this
   * size is unused by the current UI. Kept in the model (never removed) so
   * values round-trip and older clients/saved settings keep working. Remove
   * only after every deployed display runs a build that ignores it.
   */
  cardMemoFontSize: number;
  /**
   * @deprecated Per-card status badges were removed, so this size is unused by
   * the current UI. Retained for backward compatibility (round-trip + older
   * clients). Remove only in a coordinated cleanup once nothing reads it.
   */
  statusChipFontSize: number;
  statFontSize: number;
  clockFontSize: number;
  presentBackgroundColor: string;
  absentBackgroundColor: string;
  meetingBackgroundColor: string;
  etcBackgroundColor: string;
  // Seconds between automatic page changes when the board has multiple pages.
  pageRollIntervalSec: number;
}

export const defaultDisplaySettings: DisplaySettings = {
  cardTitleFontSize: 48,
  cardPositionFontSize: 28,
  cardMemoFontSize: 16,
  statusChipFontSize: 16,
  statFontSize: 20,
  clockFontSize: 30,
  presentBackgroundColor: '#0ebe72',
  absentBackgroundColor: '#eceef1',
  meetingBackgroundColor: '#fff8ec',
  // Matches the legacy hardcoded tint used for custom/extra statuses so old
  // boards render identically until an admin picks a distinct "기타" color.
  etcBackgroundColor: '#fff8ec',
  pageRollIntervalSec: 10,
};

export function mergeDisplaySettings(
  displaySettings?: Partial<DisplaySettings>,
): DisplaySettings {
  const merged = { ...defaultDisplaySettings, ...(displaySettings || {}) };
  // Backward compatibility: settings saved before name/position sizes were
  // split have no `cardPositionFontSize`. Older clients rendered the position
  // at 0.58em of the title, so backfill that proportion to keep existing
  // boards visually unchanged until an admin sets an explicit value.
  if (displaySettings?.cardPositionFontSize == null) {
    merged.cardPositionFontSize = Math.round(merged.cardTitleFontSize * 0.58);
  }
  return merged;
}
